import{__assign as r}from'./../../../../dependencies/tslib/tslib.es6.mjs';import{jsx as t}from"react/jsx-runtime";import{content as e}from"../Alert.variants.mjs";var i=function(i){var m=i.children;return t("div",r({className:e()},{children:m}))};export{i as AlertContent};
//# sourceMappingURL=AlertContent.mjs.map
